import http from '../../services/http/index';
import forResponse from '../../utils/forResponse';
import { FANCLUB_PURCHASE_INFO_URL, GET_PRODUCT_PURCHASE_INFO } from '../../constants/apiUrls/apiUrls';
import callApi from '../../utils/callApi';

export const getFanclubPurchaseInfo = (anchorId, username) => {
  const url = FANCLUB_PURCHASE_INFO_URL.
    replace('{anchorId}', encodeURIComponent(anchorId)).
    replace('{username}', encodeURIComponent(username));

  return forResponse(http.get(url));
};

export const getPurchaseInfo = (packageId, anchorId, trackingData) => {
  const url = GET_PRODUCT_PURCHASE_INFO.replace('{id}', packageId);
  const { passThrough } = trackingData || {};
  const payload = {};
  if (passThrough?.affiliateCode?.length) {
    payload.affiliateCode = passThrough.affiliateCode;
  }

  if (passThrough?.hash?.length) {
    payload.campaignHash = passThrough.hash;
  }

  return callApi(url, 'post', { anchorId }, payload, {}, true, true);
};
